<template>
  <article class="album-preview" :class="{'album-expanded': isExpanded}" v-if="record">
    <router-link :to="'/catalog/' + record.slug">
      <div class="album-img-block">
        <img v-if="record.cover" :src="record.cover.path" />
        <img v-else src="/themes/caramba/assets/images/album.jpg" />
      </div>
      <div class="album-title-block">
        <h1 class="title-small regular">{{record.artist_name}}</h1>
        <h2 class="title-small light">{{record.title}}</h2>
      </div>
    </router-link>

    <p class="normal arial">{{record.category && record.category.name}}</p>
    <div class="album-toggle-block">
      <a href="#0" class="tracklist-toggle" @click.prevent="toggleTracklist"><span></span></a>
    </div>
    <div class="tracklist-single">
      <ul>
        <li v-for="song in songsToShow" :key="song.id">
          <router-link :to="'/catalog/' + record.slug + (song.queryString || '')">
            <span class="bold">{{song.title}}</span><br>
            <span v-if="song.genre != null" class="regular">{{song.genre.name}}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
export default {
  props: ['record', 'isExpandedDefaultState', 'genre', 'song'],

  data() {
    return {
      isExpanded: false,
      songsToShow: []
    }
  },

  created() {
    this.isExpanded = this.$props.isExpandedDefaultState;
  },

  mounted() {
    this.update();
  },

  /*
   * Watch is needed as the component is not always destroyed
   * For example, if I query "Reggaeton del rigaton" from the
   * albums, and then query it again from the autocomplete by
   * searching the song "Reggaeton del rigaton", the record will
   * be the same, but this component won't be destroyed and recreated.
   * So we listen for changes to update the contents
   */
  watch: {
    record: function(newVal, oldVal) {
      this.update();
    },

    genre: function(newVal, oldVal) {
      this.update();
    },

    song: function(newVal, oldVal) {
      this.update();
    },

    isExpandedDefaultState: function(newVal, oldVal) {
      this.isExpanded = newVal;
    }
  },

  methods: {
    toggleTracklist: function(e) {
      this.isExpanded = !this.isExpanded;
    },

    update: function() {
      if(this.genre.activeId == -1 && this.song.activeId == -1) {
        this.songsToShow = this.record.songs;
      } else
      // more restrictive. if there is a song match, it's implicit that it also matches the genre
      if(this.song.activeId != -1) {
        this.songsToShow = this.record.songs.filter(song => song.id == this.song.activeId);
        this.songsToShow = this.songsToShow.map(song => {
          song.queryString = '?song=' + song.slug;
          return song;
        });
      } else
      // less restrictive
      if(this.genre.activeId != -1) {
        this.songsToShow = this.record.songs.filter(song => song.genre && song.genre.id == this.genre.activeId);
        this.songsToShow = this.songsToShow.map(song => {
          if(song.genre) song.queryString = '?genre=' + song.genre.id;
          return song;
        });
      }      
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
		@util reset-list;
  }
</style>


// WEBPACK FOOTER //
// src/vue/components/CatalogResultsResult.vue